import { render, staticRenderFns } from "./account-nav.vue?vue&type=template&id=2f2d78f8&"
import script from "./account-nav.vue?vue&type=script&lang=ts&"
export * from "./account-nav.vue?vue&type=script&lang=ts&"
import style0 from "./account-nav.vue?vue&type=style&index=0&id=2f2d78f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports